module.exports = "/_next/static/images/7ce15edc4b9657d38a0a023f9842fb1d-open-graph.jpg.webp";